import { useCallback, useEffect, useState } from 'react';
import { Button, Text } from '@chakra-ui/react';

import { VisaStatus } from 'types';
import { Modal } from 'shared-components';

import { AdditionalQuestions } from './helpers/additional-questions/index';
import { ConfirmationBlock } from './helpers/confirmation-block';
import { IntroWrapper } from './helpers/intro-wrapper';
import { WhatIsYourVisaStatus } from './helpers/what-is-your-visa-status';

import { IVisaStatus } from '../../../../../../types';

interface IProps {
  onModalClose: () => void;
  saveVisaStatus: (data: { status: IVisaStatus }) => void;
  visaStatus: IVisaStatus;
}

export const VisaStatusModal = (props: IProps) => {
  const { onModalClose, saveVisaStatus } = props;

  const visaStatus = props.visaStatus || VisaStatus.NONE;

  const [selectedStatus, setSelectedStatus] = useState<IVisaStatus>(visaStatus);
  const [selectedAdditionalStatus, setSelectedAdditionalStatus] = useState<IVisaStatus>(visaStatus);

  const showConfirmationBlock = visaStatus !== VisaStatus.NONE;
  const [isQuestionAllowed, setIsQuestionAllowed] = useState<boolean | undefined>(
    !showConfirmationBlock ? true : undefined
  );

  const [additionalQuestionsComplete, setAdditionalQuestionsComplete] = useState<boolean>(false);

  useEffect(() => {
    // sync selected additional status with selected status
    setSelectedAdditionalStatus(selectedStatus);
  }, [selectedStatus]);

  const saveVisaStatusHandler = useCallback(() => {
    saveVisaStatus({ status: selectedAdditionalStatus });

    onModalClose();
  }, [saveVisaStatus, selectedAdditionalStatus, onModalClose]);
  const closeEnabled = isQuestionAllowed === false;
  const submitEnabled = additionalQuestionsComplete && !closeEnabled;
  return (
    <Modal
      id={'VisaStatusModal'}
      show={true}
      title={visaStatus === VisaStatus.NONE ? 'Set Your Current Visa Status' : 'Update Your Visa Status'}
      onClose={onModalClose}
      footer={
        <Button
          id="enrolment-section-visa-status-save-button"
          isDisabled={!(submitEnabled || closeEnabled)}
          onClick={() => {
            if (submitEnabled) {
              saveVisaStatusHandler();
            } else {
              onModalClose();
            }
          }}
          variant="solid"
          size="lg"
        >
          {closeEnabled ? 'Close' : 'Continue'}
        </Button>
      }
    >
      <div data-selector="enrolment-section-visa-status-modal">
        <IntroWrapper visaStatus={visaStatus} />

        {showConfirmationBlock && (
          <>
            <ConfirmationBlock setConfirmation={setIsQuestionAllowed} />

            {isQuestionAllowed === false && (
              <Text>If nothing has changed with your visa status you can close this window.</Text>
            )}
          </>
        )}

        {isQuestionAllowed && (
          <>
            <WhatIsYourVisaStatus
              visaStatus={visaStatus}
              selectedStatus={{
                status: selectedStatus,
                setStatus: setSelectedStatus
              }}
            />

            <AdditionalQuestions
              visaStatus={visaStatus}
              setComplete={setAdditionalQuestionsComplete}
              status={selectedStatus}
              selectedStatus={{
                setStatus: setSelectedAdditionalStatus
              }}
            />
          </>
        )}
      </div>
    </Modal>
  );
};
